function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level3_svg__b",
  x1: 53.37,
  y1: 86.48,
  x2: 22.97,
  y2: -13.07,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level3_svg__a",
  x1: 24.79,
  y1: -22.06,
  x2: 43.76,
  y2: 61.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level3_svg__c",
  x1: 55.04,
  y1: 82.63,
  x2: 33.28,
  y2: 23.27,
  xlinkHref: "#3-level3_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#3-level3_svg__b)",
  d: "M76 36.15l-7.56-9.89.3-12.45-11.93-3.55L49.74 0 38 4.15 26.25 0l-7.06 10.26-11.93 3.55.3 12.45L0 36.15l7.56 9.89-.3 12.45 11.93 3.55 7.06 10.26L38 68.15l11.74 4.15 7.07-10.26 11.93-3.55-.3-12.45L76 36.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 13.5a22.65 22.65 0 1022.65 22.65A22.65 22.65 0 0038 13.5z",
  fill: "url(#3-level3_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 18.13a18 18 0 1018 18 18 18 0 00-18-18z",
  fill: "url(#3-level3_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.82 34.62l2.64-2.16H34v-2.18h7.7v2l-2.64 2.05a3.2 3.2 0 013 3.26c0 1.9-1.56 3.61-4.2 3.61a3.94 3.94 0 01-4.23-3.43l2.5-.46A1.68 1.68 0 0037.85 39a1.47 1.47 0 001.59-1.47 1.42 1.42 0 00-1.54-1.45 2.2 2.2 0 00-1 .25z",
  fill: "#fff"
}));

function Svg3Level3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 72.3"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNzYgNzIuMyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iNTMuMzciIHkxPSI4Ni40OCIgeDI9IjIyLjk3IiB5Mj0iLTEzLjA3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMjNjMzg2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODBlOGJiIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIyNC43OSIgeTE9Ii0yMi4wNiIgeDI9IjQzLjc2IiB5Mj0iNjEuNTMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMDc3NjMiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyM2MzODYiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYyIgeDE9IjU1LjA0IiB5MT0iODIuNjMiIHgyPSIzMy4yOCIgeTI9IjIzLjI3IiB4bGluazpocmVmPSIjYSIvPjwvZGVmcz48ZyBkYXRhLW5hbWU9IkxheWVyIDIiPjxwYXRoIGZpbGw9InVybCgjYikiIGQ9Ik03NiAzNi4xNWwtNy41Ni05Ljg5LjMtMTIuNDUtMTEuOTMtMy41NUw0OS43NCAwIDM4IDQuMTUgMjYuMjUgMGwtNy4wNiAxMC4yNi0xMS45MyAzLjU1LjMgMTIuNDVMMCAzNi4xNWw3LjU2IDkuODktLjMgMTIuNDUgMTEuOTMgMy41NSA3LjA2IDEwLjI2TDM4IDY4LjE1bDExLjc0IDQuMTUgNy4wNy0xMC4yNiAxMS45My0zLjU1LS4zLTEyLjQ1TDc2IDM2LjE1eiIvPjxwYXRoIGQ9Ik0zOCAxMy41YTIyLjY1IDIyLjY1IDAgMTAyMi42NSAyMi42NUEyMi42NSAyMi42NSAwIDAwMzggMTMuNXoiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNMzggMTguMTNhMTggMTggMCAxMDE4IDE4IDE4IDE4IDAgMDAtMTgtMTh6IiBmaWxsPSJ1cmwoI2MpIi8+PHBhdGggZD0iTTM1LjgyIDM0LjYybDIuNjQtMi4xNkgzNHYtMi4xOGg3Ljd2MmwtMi42NCAyLjA1YTMuMiAzLjIgMCAwMTMgMy4yNmMwIDEuOS0xLjU2IDMuNjEtNC4yIDMuNjFhMy45NCAzLjk0IDAgMDEtNC4yMy0zLjQzbDIuNS0uNDZBMS42OCAxLjY4IDAgMDAzNy44NSAzOWExLjQ3IDEuNDcgMCAwMDEuNTktMS40NyAxLjQyIDEuNDIgMCAwMC0xLjU0LTEuNDUgMi4yIDIuMiAwIDAwLTEgLjI1eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=";
export { Svg3Level3 as ReactComponent };